import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Suffix extends BaseOption {
  static userInterfaceComponent = {
    label: "Suffix",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
